<template>
  <b-container fluid>
    <b-row class="mb-4">
      <b-link
        :to="{
          name:'Keuringsrapporten'
        }"
        class="text-secondary font-lg"
      >
        <font-awesome-icon icon="arrow-left" /> Terug naar overzicht
      </b-link>
    </b-row>
    <b-row v-if="data">
      <b-col
        cols="7"
        :style="{'min-height':height+'px','z-index':0}"
      >
        <PdfViewer
          :pdf="base64src"
        />
      </b-col>
      <b-col>
        <b-card no-body>
          <b-card-header>
            <div class="card-header-actions">
              <b-button
                variant="danger"
                @click="deleteRapport"
              >
                <i class="fa fa-trash" /> Rapport verwijderen
              </b-button>
            </div>
            <b-card-title><i :class="[icons[data.icon], 'm-3']" /> Rapport</b-card-title>
            <b-card-sub-title>{{data.type}} via {{ data.instantie }} API</b-card-sub-title>
          </b-card-header>
          <b-overlay
            v-if="data.unit.id !== 'NONE'"
            variant="dark"
            :show="process_running === 'process-report'"
          >
            <b-card-body>
              <b-card-title>Unit</b-card-title>
              <b-card-text class="my-4">
                <div
                  v-for="(u,index) in data.unit.info"
                  :key="index"
                >
                  {{ u }}
                </div>
                
                <b-link :to="{name:'Algemeen',params:{id:data.unit.id}}">
                  <font-awesome-icon icon="eye" />
                  Ga naar unit
                </b-link>
              </b-card-text>
            
              <b-form-group
                label="Keuringsdatum"
                :description="isPeriodiekeKeuring ? 'Bij verwerking wordt dit de nieuwe keuringsdatum van de unit. Dit is een periodieke keuring.' : 'De datum wordt alleen overgenomen bij een periodieke keuring.'"
              >
                <!--- checkbox-->
                <b-form-checkbox
                  v-model="updates['DATE']"
                  disabled
                >
                  {{ data.datum }}
                </b-form-checkbox>
              </b-form-group>
              <b-form-group
                label="Uitslag"
                description="Bij verwerking wordt dit de nieuwe keuringsstatus van de unit"
              >
                <!--- checkbox-->
                <b-form-checkbox
                  v-model="updates['RESULT']"
                  disabled
                >
                  {{ data.resultaat }}
                </b-form-checkbox>
              </b-form-group>
              <b-form-group
                label="Opmerkingen"
                description="Bij verwerking worden deze opmerkingen toegevoegd aan het document"
              >
                <!--- checkbox-->
                <b-form-checkbox
                  v-model="updates['REMARKS']"
                  disabled
                >
                  {{ data.opmerkingen.length }} opmerkingen
                </b-form-checkbox>
                <ul>
                  <li
                    v-for="(o,index) in data.opmerkingen"
                    :key="index"
                  >
                    {{ o }}
                  </li>
                </ul>
              </b-form-group>

              <b-form-group>
                {{ data.error }}
              </b-form-group>
            </b-card-body>
            <b-card-footer>
              <b-button
                block
                variant="primary"
                @click="processReport"
              >
                <i class="fa fa-play" />
                Dit rapport verwerken
              </b-button>
            </b-card-footer>
          </b-overlay>
          <b-overlay
            v-else
            :show="process_running === 'match-unit'"
            variant="dark"
          >
            <!--- component om het rapport bij geen unit te matchen via het keuringsnummer -->
            <KeuringrapportMatch
              :keuringsnummer="data.keuringsnummer"
              @tryMatchUnit="tryMatchUnit"
            >
              <b-card-body v-if="match_error">
                <b-alert
                  variant="danger"
                  show
                >
                  {{ match_error }} 
                </b-alert>
              </b-card-body>
            </KeuringrapportMatch>
          </b-overlay>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin";
import VuePdfApp from "vue-pdf-app";
import KeuringrapportMatch from "./KeuringrapportMatch.vue";
export default {
  name: "KeuringQueueDetail",
  components: {
        PdfViewer : VuePdfApp,
        KeuringrapportMatch,
        // pdf
      },
  mixins: [serviceMixin],
  data() {
    return {
      process_running: 'none',
      math_error: null,
      updates: {
        "FORMAT":"CODE",
        "DATE":true,
        "RESULT":true,
        "REMARKS":true,
      },
      height:600,
      data: null,
      selected_pdf: null,
      icons: {
        "HOLD": "fa fa-pause",
        "COMPLETED": "fa fa-check",
        "SKIP": "fa fa-check",
        "DELETED" : "fa fa-trash",
        "FAILED": "fa fa-exclamation-triangle",
      }
    };
  },
  computed: {
    isPeriodiekeKeuring() {
      // convert data.is_periodieke_keuring (1 or 0) to true false for 
      // easier handling in the template
      return this.data && this.data.is_periodieke_keuring === 1;
      //return this.data && this.data.type.toUpperCase().includes('PERIODIEKE KEURING');
    },
    path() {
      return this.$route.path;
    },
    base64src() {
      return `data:application/pdf;base64,${this.data.base64}`;
    },
  },
  mounted() {
    this.getReport(this.path);
    this.setPreviewHeight();
  },
  methods: {
    tryMatchUnit() {
      this.process_running = 'match-unit';
      this.post(this.$route.path, { action: 'match-unit'}).then((response) => {
          console.log(response);
          if (response.data.success === true) {
            this.getReport(this.path);
          }
      }).catch((error) => {
          console.error(error);
          this.match_error = error.response.data.error;
      }).finally(() => {
          this.process_running = 'none';
      });
    },
    processReport() {
      var vm = this;
      this.process_running = 'process-report';
      this.post(this.path, { action: 'process-report', updates: this.updates }).then((response) => {
        console.log(response.data);
        if (response.data.success === true) {
          console.log(response.data);
          vm.$router.push({ name: "Keuringsrapporten" });
        }
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        this.process_running = 'none';
      });
    },
    deleteRapport() {
      var vm = this;
      this.delete(this.path).then((response) => {
        console.log(response.data);
        if (response.data.success === true) {
          console.log(response.data);
          vm.$router.push({ name: "Keuringsrapporten" });
        }
      });
    },
    setPreviewHeight() {
      this.height = window.innerHeight - 315 ;
    },
    getReport(path) {
      this.data = null;
      this.selected_pdf = null;
      this.get(path).then((response) => {
        this.data = response.data;
        this.updates['DATE'] = this.isPeriodiekeKeuring;
        console.dir(response.data);
      });
    },
  },
};
</script>